<template>
  <div class="container">
    <div class="row mt-5">
      <div class="col-lg-5 col-md-12">
        <div class="welcome-text">
          <h1>{{ $t('reset-password.forgot-password') }}</h1>
          <div class="description">
            <p class="pt-3">{{ $t('reset-password.password-recovery-method') }}</p>
            <div class="form-group py-4">
              <el-radio v-model="method" v-if="email" label="email">{{ $t('reset-password.recovery-via-email') }}</el-radio>
              <el-input
                  class="iin-recover mb-3"
                  v-if="email"
                  :placeholder="$t('profile.iin-label')"
                  v-model="email"
                  disabled
                  autocomplete="off">
              </el-input>
              <el-radio v-model="method" label="sms">{{ $t('reset-password.recovery-via-sms') }}</el-radio>
              <el-input
                  class="iin-recover"
                  :placeholder="$t('profile.iin-label')"
                  v-model="phone"
                  disabled
                  autocomplete="off">
              </el-input>
            </div>
            <div class="form-group pt-5">
              <el-button type="primary" @click="next">{{ $t('reset-password.next-btn') }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-12 py-5">
        <img src="/images/signin-bg.svg" width="610" style="max-width: 100%;">
      </div>
    </div>
  </div>
</template>
<script>
import LoginForm from '@/components/LoginForm'

export default {
  name: 'Login',
  components: {
    LoginForm
  },
  data() {
    return {
      method: 'email',
      email: '',
      phone: '',
    }
  },
  methods: {
    next() {
      this.$router.push('/forget-password/' + this.method);
    },
  },
  mounted() {
    if (localStorage.getItem('user-recovery')) {
      const data = JSON.parse(localStorage.getItem('user-recovery'))
      this.email = data.email
      this.phone = data.phone

      if(!data.email) {
        this.method = 'sms'
      }
    }
  }
}
</script>

<style>
.el-radio {
  display: flex;
}
</style>